import { type ComponentProps } from 'react';
import { StyleSheet } from 'react-native';
import { LI } from '@expo/html-elements';
import { theme } from '@garnish/constants';

import { LabelText } from '../../../../../Text';

// ─────────────────────────────────────────────────────────────────────────────

export const Item = (props: ItemProps) => {
  const { value, label } = props;

  return (
    <LI style={styles.lineItem}>
      <LabelText sizeMatch={TEXT_SIZE_MATCH}>
        <LabelText
          sizeMatch={TEXT_SIZE_MATCH}
          style={styles.nutritionDataText}
          bold
        >
          {value}
        </LabelText>

        <LabelText sizeMatch={TEXT_SIZE_MATCH}> </LabelText>

        <LabelText sizeMatch={TEXT_SIZE_MATCH} style={styles.label}>
          {label}
        </LabelText>
      </LabelText>
    </LI>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  lineItem: {
    flexDirection: 'row',
  },
  nutritionDataText: {
    color: theme.colors.TEXT_COLOR,
    textTransform: 'uppercase',
  },
  label: {
    color: theme.colors.CHARCOAL,
    textTransform: 'uppercase',
  },
});

// ─── Constants ───────────────────────────────────────────────────────────────

const TEXT_SIZE_MATCH: ComponentProps<typeof LabelText>['sizeMatch'] = ['12'];

// ─── Types ───────────────────────────────────────────────────────────────────

type ItemProps = {
  value: string | number;
  label: string;
};
